import React, { Component, lazy } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import { connect } from 'react-redux'
import { ROUTE_PATH } from "../utils/Global"

import { mode } from 'webconfig'

import TopBarV2 from "../Common/TopBarV2"
import MakeVideo from "../Routers/MakeVideo"
import AiTools from "../Routers/AiTools"
import ShortsCustomizing from "../Routers/ShortsCustomizing"
import BandBanner from '../BandBanner'
import ChatPage from "../Routers/ChatPage"

const Footer = lazy(() => import("../Footer"))
const Home = lazy(() => import("../Home"))
const DesignSelect = lazy(() => import("../Routers/designSelect"))
const Share = lazy(() => import("../Routers/share"))

const SignUp = lazy(() => import("../SignUp/SignUp"))
const Login = lazy(() => import("../Routers/Login"))
const UserPage = lazy(() => import("../Routers/UserPage"))
const UseGuide = lazy(() => import("../Routers/useGuide"))
const EventPage = lazy(() => import("../Routers/EventPage"))
const FAQ = lazy(() => import("../Routers/faq"))
const AdminPage = lazy(() => import("../Routers/AdminPage"))
const Payment = lazy(() => import("../Routers/payment"))
const LoginAfterStep = lazy(() => import("../LoginAfterStep/LoginAfterStep1/LoginAfterStep"))
const LoginAfterStep2 = lazy(() => import("../LoginAfterStep/LoginAfterStep2/LoginAfterStep2"))
const LoginAfterStep3 = lazy(() => import("../LoginAfterStep/LoginAfterStep3/LoginAfterStep3"))

const Tos = lazy(() => import('../Footer/TOS'))
const Privacy = lazy(() => import('../Footer/Privacy'))
const Copyright = lazy(() => import('../Footer/Copyright'))
const AiTerm = lazy(() => import('../Footer/AiTerm'))
const RequiredBox = lazy(() => import('../SignUp/requiredBox/requiredBox'))
// const Selectdesigner = lazy(() => import('../ShopAndShop/SelectDesigner/SelectDesigner'))
const Start = lazy(() => import('../Start/Start'))
const SocialWithdraw = lazy(() => import("../SocialWithdraw/SocialWithdraw"))
const Gallery = lazy(() => import("../Gallery/Gallery"))
const UserGallery = lazy(() => import("../Gallery/UserGallery"))
const Duplicated = lazy(() => import("../Routers/Duplicated"))
const AboutUs = lazy(() => import('../AboutUs'))
const Ecommerce = lazy(() => import('../Ecommerce'))
const DeleteAccount = lazy(() => import('../DeleteAccount/DeleteAccount'))
const Test = lazy(() => import('../_Test'))
const NaverSearch = lazy(() => import('../NaverSearch'))

const PaidResult = lazy(() => import('../_mobile/PaidResult'))

const StudioRootContainer = lazy(() => import('../Studio'))
const MyPageRootContainer = lazy(() => import('../MyPage'))

class Videomonster extends Component {

    listenLocationChange = (props) => { this.props.listenLocationChange(props) }

    render() {
        const { isMobile, changeLanguage } = this.props
        const { location: { pathname } } = window
        const pathnameArray = pathname.split('/')

        const firstPath = pathnameArray.length > 1 ? pathnameArray[1] : null
        let showHeader = true;
        let isBlackHeader = false;
        let hideMenuArea = false;
        let showFooter = true;
        switch (firstPath) {
            case '':
            case 'home':
                isBlackHeader = true;
                break;
            case 'admin':
            case 'chat':
                showHeader = false;
                showFooter = false;
                break;

            case 'studio':
            case 'shorts-customizing':
            case 'makevideo':
                hideMenuArea = true;
                showFooter = false;
                break;

            case 'user':
                showFooter = false;
                break;
        }

        return (
            <>
                {
                    showHeader &&
                    <>
                        <BandBanner {...this.props}/>
                        <TopBarV2 minWidth={1426 - 40} hideMenuArea={hideMenuArea} {...this.props} black={isBlackHeader} />
                    </>
                }
                <Switch>
                    <Route
                        exact
                        path="/"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Home
                                {...props}
                                isMobile={isMobile}
                            />
                        }}
                    />

                    <Route
                        path="/home"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Home
                                {...props}
                                isMobile={isMobile}
                            />
                        }}
                    />

                    <Route
                        path="/designselect"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Redirect to={ROUTE_PATH.DESIGN_SELECT} />
                        }}
                    />

                    <Route
                        path="/gallery"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Gallery {...props} isMobile={isMobile} />
                        }}
                    />

                    <Route
                        path="/naver-search"
                        component={props => {
                            this.listenLocationChange(props)
                            return <NaverSearch {...props}/>
                        }}
                    />

                    <Route
                        path="/user-gallery/:id"
                        component={props => {
                            this.listenLocationChange(props)
                            return <UserGallery {...props} isMobile={isMobile} />
                        }}
                    />
                    <Route
                        path="/event"
                        component={props => {
                            this.listenLocationChange(props)
                            return <EventPage {...props} />
                        }}
                    />
                    <Route
                        path="/useguide"
                        component={props => {
                            this.listenLocationChange(props)
                            return <UseGuide {...props} />
                        }}
                    />

                    <Route
                        path="/payment"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Payment {...props} />
                        }}
                    />

                    <Route
                        path="/faq"
                        component={props => {
                            this.listenLocationChange(props)
                            return <FAQ />
                        }}
                    />

                    <Route
                        path="/studio"
                        component={props => {
                            this.listenLocationChange(props)
                            return <StudioRootContainer {...props} />
                        }}
                    />

                    {/* <Route
                        path="/login"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Login {...props} />
                        }}
                    />

                    <Route
                        path="/Signup"
                        component={props => {
                            this.listenLocationChange(props)
                            return <SignUp {...props} />
                        }}
                    /> */}

                    <Route
                        path="/makevideo"
                        component={props => {
                            this.listenLocationChange(props)
                            return <MakeVideo {...props} />
                        }}
                    />

                    <Route
                        path="/aitools"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Redirect to={ROUTE_PATH.AI_TOOLS} />
                        }}
                    />

                    <Route
                        path="/shorts-customizing"
                        component={props => {
                            this.listenLocationChange(props)
                            return <ShortsCustomizing {...props} />
                        }}
                    />
                    <Route
                        path="/share"
                        component={props => {
                            return <Share {...props} />
                        }} />

                    <Route
                        path="/Tos"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Tos {...props} />
                        }}
                    />

                    <Route
                        path="/Privacy"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Privacy {...props} />
                        }}
                    />

                    <Route
                        path="/Copyright"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Copyright {...props} />
                        }}
                    />

                    <Route
                        path="/ai-product-term"
                        component={props => {
                            this.listenLocationChange(props)
                            return <AiTerm {...props} />
                        }}
                    />

                    <Route
                        path="/admin"
                        component={props => {
                            return <AdminPage {...props} />
                        }}
                    />

                    <Route
                        path="/requiredbox"
                        component={props => {
                            this.listenLocationChange(props)
                            return <RequiredBox {...props} />
                        }}
                    />

                    <Route path="/LoginAfterStep" component={LoginAfterStep} />
                    <Route path="/LoginAfterStep2" component={LoginAfterStep2} />
                    <Route path="/LoginAfterStep3" component={LoginAfterStep3} />

                    <Route
                        path="/user/:id"
                        component={props => {
                            this.listenLocationChange(props)
                            return <MyPageRootContainer {...props} />
                        }}
                    />

                    <Route
                        path="/aboutus"
                        component={props => {
                            this.listenLocationChange(props)
                            return <AboutUs {...props} />
                        }}
                    />

                    <Route
                        path="/ecommerce"
                        component={(props) => {
                        this.listenLocationChange(props);
                        return <Ecommerce {...props} />;
                        }}
                    />

                    {/* <Route
                        path="/designershop"
                        component={props => {
                            this.listenLocationChange(props)
                            return <Selectdesigner {...props} />
                        }}
                    /> */}
                    <Route
                        path="/start"
                        component={props => (
                                <Start {...props} ></Start>
                            )
                        }
                    />
                    {/* sns회원 탈퇴후 24시간이내 회원가입 시도시 이쪽으로 처리 */}
                    <Route
                        path="/socialnotfound"
                        component={
                            props => {
                                return <SocialWithdraw {...props} />
                            }
                        }
                    />
                    <Route
                        path="/socialwithdraw"
                        component={
                            props => {
                                return <SocialWithdraw {...props} />
                            }
                        }
                    />

                    <Route path="/chat" component={props => <ChatPage {...props} />} />

                    <Route path="/paid-result" component={props => <PaidResult {...props} />} />
                    <Route path="/duplicated" component={props => <Duplicated {...props} />} />
                    <Route path="/delete-account-guide" component={props => <DeleteAccount {...props} />} />

                    <Route path="/make" component={() => <Redirect to={'/designSelect'} />} />
                    <Route path="/myVideo" component={() => <Redirect to={'/user/_/my-video'} />} />
                    <Route path="/shop" component={() => <Redirect to={'/payment'} />} />


                    {
                        // 개발 테스트용 페이지
                        (mode !== "stage") && <Route
                            path="/test"
                            component={props => {
                                this.listenLocationChange(props)
                                return <Test {...props} />
                            }}
                        />
                    }

                    <Route component={() => <Redirect to={'/'} />} />
                </Switch>

                {
                    showFooter && <Footer {...this.props} />
                }
            </>
        )
    }
}

export default connect(
    null,
    null
)(Videomonster);